import { render, staticRenderFns } from "./loginas.vue?vue&type=template&id=5c800fe8"
import script from "./loginas.vue?vue&type=script&lang=js"
export * from "./loginas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports